import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterEliminateNoteWithdraw from 'views/management/eliminateNoteWithdraw/filterEliminateNoteWithdraw'; // Importing filter component
import RecargaEliminateNoteWithdraw from 'views/management/eliminateNoteWithdraw/EliminateNoteWithdraw'; // Importing recharge component
import TableEliminateNoteWithdraw from 'views/management/eliminateNoteWithdraw/tableEliminateNoteWithdraw'; // Importing table component
import FilterTableEliminateNoteWithdraw from 'views/management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw'; // Importing filter for table
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the eliminate note withdraw view.
 * @extends JetView
 */
export default class eliminateNoteWithdrawView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Eliminar Nota de Retiro'), // Localized label
                            width: 300,
                        },
                    ],
                },
                FilterEliminateNoteWithdraw, // Filter component
                RecargaEliminateNoteWithdraw, // Recharge component
                FilterTableEliminateNoteWithdraw, // Table filter component
                TableEliminateNoteWithdraw, // Table component
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main layout configuration
        return {
            type: 'wide',
            responsive: true,
            css: 'out',
            cols: [left, { view: 'resizer' }], // Layout with left panel and resizer
        };
    }
}

// FILE DOCUMENTED
